import React,{useState} from 'react'
import {makeStyles} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
import Navigation from './Navigation';
import CloseIcon from '@material-ui/icons/Close';
import {motion} from 'framer-motion'
function MobileNav() {
    const [open,setOpen] = useState(false);
    const useStyles = makeStyles((theme)=>({
        ham_icon:{
            cursor: 'pointer',
            position:'fixed',
            height:'45px',
            width:'45px',
            borderRadius:'50%',
            backgroundColor:'#fff',
            display: 'flex',
            alignItems:'center',
            justifyContent:'center',
            top:'10px',
            left:'20px',
            zIndex:'90',
            boxShadow:'1px 2px 5px rgba(0,0,0,0.2)',
            visibility: 'hidden',
            [theme.breakpoints.down('md')]:{
                visibility: 'visible'
            }
        },
        sideMenu:{
            visibility:open?'visible':'hidden',
           
           width:'100%' ,
           display: 'flex',
           flexDirection:'column',
           alignItems:'center',
           textAlign:'center',
           paddingTop:'60px',
            height:'190vh',
        backgroundColor:'#fff',
        position: 'fixed',
        zIndex:'60',
        [theme.breakpoints.up('lg')]:{
            visibility: 'hidden'
        }
        }
    }))
    const classes = useStyles();
   
    let openHamMenu = ()=>{
       
setOpen(!open);
    }
    let closeHam=()=>{
        setOpen(false);
    }
    return (
        <div className={classes.hamMenu}>

            <div className={classes.ham_icon} onClick={()=>openHamMenu()}>
                {open?<CloseIcon style={{color:'teal'}}/>:<MenuIcon style={{color:'teal'}}/>}


            </div>

<motion.div className={classes.sideMenu} initial={{height:'0'}} animate={{height:'100%'}} transition={{duration:2}}>
<Navigation closeHam={closeHam}/>
</motion.div>


            
        </div>
    )
}

export default MobileNav
